import { render, staticRenderFns } from "./PhotoCarousel.vue?vue&type=template&id=ef2a25a6&"
import script from "./PhotoCarousel.vue?vue&type=script&lang=ts&"
export * from "./PhotoCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./PhotoCarousel.vue?vue&type=style&index=0&id=ef2a25a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports